/**
 * Backend names images extracted from a pasted <img> tag "pasted-image-<n>.<ext>" — the only
 * signal currently available to tell a clipboard paste apart from a drag/attach-button upload.
 */
const PASTED_IMAGE_NAME_PATTERN = /^pasted-image-\d+\.[a-z0-9]+$/i;

/** @param {{ mimeType?: string, contentType?: string, name?: string, originalName?: string, fileName?: string }} attachment */
export function isPastedImageAttachment(attachment) {
  const mimeType = String(attachment?.mimeType ?? attachment?.contentType ?? "");
  if (!mimeType.startsWith("image/")) return false;
  const name = String(attachment?.name ?? attachment?.originalName ?? attachment?.fileName ?? "");
  return PASTED_IMAGE_NAME_PATTERN.test(name);
}

/**
 * Split a comment's attachments into pasted images (rendered as an inline preview) vs.
 * everything else (rendered as the existing file-chip row) — unrelated attachments are
 * untouched, same order preserved within each group.
 * @param {Array} attachments
 */
export function splitCommentAttachments(attachments) {
  const list = Array.isArray(attachments) ? attachments : [];
  const pastedImages = list.filter(isPastedImageAttachment);
  const other = list.filter((a) => !isPastedImageAttachment(a));
  return { pastedImages, other };
}
